import { defineStore } from 'pinia'

export const useTokenStore = defineStore(
  'userToken',
  () => {
    const refreshtoken = ref('')
    const token = ref('')
    const setRefreshtoken = (value) => {
      refreshtoken.value = value
    }
    const setToken = (value) => {
      token.value = value
    }

    const getRefreshtoken = computed(() => refreshtoken.value)
    const getToken = computed(() => token.value)

    const removeAll = () => {
      refreshtoken.value = ''
      token.value = ''
    }

    return { setRefreshtoken, setToken, getRefreshtoken, getToken, removeAll, refreshtoken, token }
  },
  {
    persist: true,
  },
)
